import { useMemo,useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MultiTable from "../../../Common/MUITable";
import {
  calculateCoveragePercent,
  filterRowsByCriteria,
} from "./reportCommon";
import {
  SecondaryCollectionPointInner,GetCollectionPoint,GetAllCircles
} from "./ReportApi";
import {
  DEFAULT_OVERVIEW_SECONDARY_COLLECTION_INNER_FILTERS  
} from "./staticReportData";
import OverviewSecondaryCollectionPointInnerFilter from "./OverviewSecondaryCollectionPointInnerFilter";
import DelhiReportExport from "./DelhiReportExport";

const toZeroSafe = (val) => {
  if (val === null || val === undefined || val === "") {
    return "0";
  }

  const num = Number(val);
  return Number.isNaN(num) ? "0" : String(num);
};

const buildInnerRow = (row) => ({
  sno: row.sno,
  circleId: row.circleId ?? null,

  wardName:
    typeof row.circleName === "string"
      ? row.circleName
      : row.circleName?.circleName ||
        row.circleName?.name ||
        row.circleName?.wardName ||
        "NA",

  typeOfWaste: row.nameTypeOfWaste || "NA",

  totalPoint: toZeroSafe(row.totalPoint),
  cleared: toZeroSafe(row.cleared),
  notCleared: toZeroSafe(row.notCleared),

  balance:
    row.balance === null ||
    row.balance === undefined ||
    row.balance === ""
      ? "0"
      : String(row.balance),

  percentOfCleared: toZeroSafe(row.percentage),
});

const tableColumns = [
  {
    label: "Ward Name",
    field: "wardName",
    width: "120px",
  },
  {
    label: "Type of waste",
    field: "typeOfWaste",
    width: "260px",
  },
  {
    label: "Total point",
    field: "totalPoint",
    width: "120px",
  },
  {
    label: "Cleared",
    field: "cleared",
    width: "110px",
  },
  {
    label: "Not Cleared",
    field: "notCleared",
    width: "120px",
  },
  // {
  //   label: "Balance",
  //   field: "balance",
  //   width: "110px",
  // },
  {
    label: "% of cleared",
    field: "percentOfCleared",
    width: "130px",
  },
];

const exportColumns = [
  { label: "Ward Name", field: "wardName" },
  { label: "Type of waste", field: "typeOfWaste" },
  { label: "Total point", field: "totalPoint" },
  { label: "Cleared", field: "cleared" },
  { label: "Not Cleared", field: "notCleared" },
  { label: "% of cleared", field: "percentOfCleared" },
];

const OverviewSecondaryCollectionPointInnerReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
 const parentRow = location.state?.parentRow;
const parentRows = location.state?.parentRows || [];
const showAllPoints = Boolean(location.state?.showAllPoints);

const collectionPointTypeId =
  location.state?.collectionPointTypeId ||
  parentRow?.collectionPointTypeId ||
  parentRow?.id ||
  null;

const lockedWasteType = showAllPoints ? null : parentRow || null;

const parentAppliedFilters = location.state?.appliedFilters;

const initialInnerFilters = {
  ...DEFAULT_OVERVIEW_SECONDARY_COLLECTION_INNER_FILTERS,
  fromDateTime:
    parentAppliedFilters?.fromDate ||
    DEFAULT_OVERVIEW_SECONDARY_COLLECTION_INNER_FILTERS.fromDateTime,
  toDateTime:
    parentAppliedFilters?.toDate ||
    DEFAULT_OVERVIEW_SECONDARY_COLLECTION_INNER_FILTERS.toDateTime,
};

  const [filters, setFilters] = useState(initialInnerFilters);
  const [appliedFilters, setAppliedFilters] = useState(initialInnerFilters);
  const [circleOptions, setCircleOptions] = useState([]);
const [reportData, setReportData] = useState([]);
const [loading, setLoading] = useState(false);
const [collectionPointOptions, setCollectionPointOptions] = useState([]);

const fetchCollectionPoints = async () => {
  try {
    const response = await GetCollectionPoint();

    console.log("COLLECTION POINT API:", response.data);

    if (Array.isArray(response.data)) {
      setCollectionPointOptions(response.data);
    } else if (Array.isArray(response.data?.data)) {
      setCollectionPointOptions(response.data.data);
    } else {
      setCollectionPointOptions([]);
    }
  } catch (error) {
    console.error("Error fetching collection points:", error);
    setCollectionPointOptions([]);
  }
};

useEffect(() => {
  fetchCollectionPoints();
   fetchCircles();
}, []);
const filteredRows = useMemo(() => {
  const rows = reportData.map(buildInnerRow);
  console.log("BUILT ROWS:", JSON.stringify(rows, null, 2));
  return rows;
}, [reportData]);

const hasWardFilter = Boolean(appliedFilters?.wardId);

const rowsToShow = useMemo(() => {
  // Remove API rows that don't belong to any ward
  const validRows = filteredRows.filter(
    (row) => row.circleId !== null && row.circleId !== undefined && row.circleId !== ""
  );

  // No ward selected → show all valid ward rows
  if (!appliedFilters?.wardId) {
    return validRows;
  }

  // Ward selected → show only that ward
  return validRows.filter(
    (row) => String(row.circleId) === String(appliedFilters.wardId)
  );
}, [filteredRows, appliedFilters?.wardId]);

const fetchCircles = async () => {
  try {
    const response = await GetAllCircles();

    console.log("CIRCLES API:", response.data);

    if (Array.isArray(response.data)) {
      setCircleOptions(response.data);
    } else if (Array.isArray(response.data?.data)) {
      setCircleOptions(response.data.data);
    } else {
      setCircleOptions([]);
    }
  } catch (error) {
    console.error("Error fetching circles:", error);
    setCircleOptions([]);
  }
};

const fetchInnerReport = async (filterValues = {}) => {
  try {
    setLoading(true);

    const response = await SecondaryCollectionPointInner({
     circleId: filterValues.wardId,
      collectionPointTypeId: collectionPointTypeId,
      fromDate: filterValues.fromDateTime,
      toDate: filterValues.toDateTime,
    });

    console.log("INNER API RESPONSE:", response.data);

    if (Array.isArray(response.data)) {
      setReportData(response.data);
    } else if (response?.data?.data) {
      setReportData(response.data.data);
    } else {
      setReportData([]);
    }
  } catch (error) {
    console.error("Error fetching secondary collection inner report:", error);
    setReportData([]);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  fetchInnerReport(initialInnerFilters);
}, [collectionPointTypeId]);

const handleSearch = async (values) => {
  setAppliedFilters(values);
  await fetchInnerReport(values);
};

const handleReset = async () => {
  const defaultFilters =
    DEFAULT_OVERVIEW_SECONDARY_COLLECTION_INNER_FILTERS;

  setFilters(defaultFilters);
  setAppliedFilters(defaultFilters);

  // Fetch default report data again
  await fetchInnerReport(defaultFilters);
};

  return (
    <div className="content text-start">
      <div className="page-content">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mt-3 mb-3">
          <div className="me-md-3">
            <h5 className="mb-1 fw-semibold">
              Overview of Secondary Collection Point Inner Report
            </h5>
            <p className="text-muted mb-0">
              View ward-wise secondary collection point details.
              {showAllPoints
                ? " (All waste types)"
                : parentRow?.typeOfWaste
                  ? ` (${parentRow.typeOfWaste})`
                  : ""}
            </p>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <button
              type="button"
              className="button-container"
              onClick={() =>
                navigate("/overview-of-secondary-collection-point-report")
              }
            >
              Back
            </button>
            <DelhiReportExport
              reportData={rowsToShow}
              reportTitle="Overview of Secondary Collection Point Inner Report"
              columns={exportColumns}
              fileName="OverviewSecondaryCollectionPointInnerReport"
            />
          </div>
        </div>

        <div className="card shadow mb-3">
          <div className="card-body">
            <OverviewSecondaryCollectionPointInnerFilter
              initialValues={filters}
              wardOptions={circleOptions}
              lockedWasteType={lockedWasteType}
              onSearch={(values) => {
                setFilters(values);
                handleSearch(values);
              }}
              onReset={handleReset}
            />
          </div>
        </div>

        <div className="card shadow">
          <div className="card-body">
            <div className="top-header text-center">
              <span>Overview of Secondary Collection Point Inner Report</span>
            </div>
            <div className="table-responsive">
              <MultiTable
                loading={loading}
                needSRNumber
                columns={tableColumns}
                rows={rowsToShow}
                tableHeight={500}
                rowsPerPageOptions={[10, 25, 50, 100]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewSecondaryCollectionPointInnerReport;
